
import { Dispatch, SetStateAction } from 'react';

import { Button, Modal, ModalInner } from 'components';
import { GroundStaionDetailData } from './types';
import axios from 'common/AxiosAuth';

interface ModalProps {
  data: GroundStaionDetailData | null;
  setData: Dispatch<SetStateAction<GroundStaionDetailData | null>>;
  onDeleted: () => void;
  setIsDeleteModalOpened: Dispatch<SetStateAction<boolean>>;
}

const DetailDeleteModal = ({ data, setData , onDeleted, setIsDeleteModalOpened}: ModalProps) => {
  const onDelete = async () => {
    if (data && data.id) {
      try {
        await axios.delete(`/api/admin/groundstation/${data.id}`);
        setIsDeleteModalOpened(false);
        setData(null);
        onDeleted();
      } catch (error: any) {
        console.error('삭제 중 에러 발생:', error.response ? error.response.data : error.message);
        // 에러 메시지를 사용자에게 표시하는 로직 추가
      }
    } else {
      console.error('삭제할 데이터가 없거나 ID가 없습니다.');
    }
  };

  const onCancel = () => {
    setIsDeleteModalOpened(false);
  };


  return (
    <Modal isOpened={true}>
      <ModalInner className="md:w-[400px]" title="Delete" onClickClose={onCancel}>
        <p className=" p-4 pt-0 text-body1">Are you sure you want to delete it? This operation cannot be undone.</p>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text="Cancel" onClick={onCancel} type="secondary" size="large" />
          <Button className="h-9  bg-red-600 border-red-600" text="Delete" onClick={onDelete} type="blue" size="large" />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DetailDeleteModal;
